/**
 * @file        src/pages/flight/CorporateConvenienceFee.jsx
 * @description Corporate Flight → Convenience Fee. Same list/form as the B2C
 *              Flight Convenience Fee (ConvenienceFee.jsx), fixed to
 *              audience=b2b, instead of forking the page.
 * @author      Kinetika Labs
 * @created     2026-08-10
 * @changelog
 *   - 2026-08-10 Claude — Initial (Corporate Flight menu parity with B2C).
 */
import ConvenienceFee from './ConvenienceFee';

export default function CorporateConvenienceFee() {
  return (
    <ConvenienceFee
      title="Corporate Convenience Fee"
      subtitle="Corporate Flight · B2B convenience fee rules"
      audience="b2b"
    />
  );
}
